import React, { Component } from 'react'
import CommonHeader from '../../navbars/CommonHeader';

// Analysis page header: the shared CommonHeader, in a colour of its own
// (page styles from .complexity-nav).
class ComplexityAnalysisNavbar extends Component {
    render() {
        return (
            <CommonHeader className="complexity-nav" color="auto" tone="light" container={false} onToggleSidebar={this.props.onClick} title={"Complexity Analysis"} />
        )
    }
}

export default ComplexityAnalysisNavbar;
